import { RootState } from 'store/index';
import { IMyPricePlan, IPricePlan } from 'services/pricePlan/types';

export const MyPricePlanSelector = (state: RootState): IMyPricePlan | undefined =>
  state.pricePlan.pricePlan;

export const PricePlansSelector = (state: RootState): IPricePlan[] => state.pricePlan.pricePlans;
